import { render } from "./UnNftHoldingHistory.vue?vue&type=template&id=258512d4"
import script from "./UnNftHoldingHistory.vue?vue&type=script&lang=js"
export * from "./UnNftHoldingHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__